export default "__VITE_PUBLIC_ASSET__cfd0d873__"